import React, { useState } from 'react';
import classnames from 'classnames';
import { FormattedDate, FormattedNumber } from 'react-intl';
import { Link } from 'react-router-dom';
import { ArrowDown, ArrowUp, WithSubRentals } from 'Utils/SvgIcons';
import { SubrentalsAllRowProps } from './SubrentalsAll.types';

const SubrentalsAllRow: React.FC<SubrentalsAllRowProps> = ({
  rentalInventory,
  link,
  location,
  multilocationAllLocations,
  onClick,
}) => {
  const [showOldName, setShowOldName] = useState(false);
  const { sub_rental, has_shortage, parent_rental } = rentalInventory;

  const startDate = rentalInventory?.rental_schedule?.offShelfAt;
  const endDate = rentalInventory?.rental_schedule?.onShelfAt;

  const orderLabel = [
    parent_rental?.token && `#${parent_rental.token}`,
    parent_rental?.name,
  ]
    .filter(Boolean)
    .join(' - ');

  const currentName = rentalInventory.inventory_name || rentalInventory.name;
  const wasRenamed = Boolean(
    rentalInventory.inventory_name &&
      rentalInventory.name &&
      rentalInventory.inventory_name !== rentalInventory.name
  );

  const toggleOldName = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setShowOldName((prev) => !prev);
  };

  return (
    <tbody>
      <Link className='rTableRow' to={link} onClick={onClick}>
        {multilocationAllLocations && (
          <td className='bold valignTop'>{location?.locationCode}</td>
        )}
        <td className='lg'>
          <p>
            <strong>{currentName || 'Untitled'}</strong>
            {wasRenamed && (
              <span
                role='button'
                tabIndex={0}
                onClick={toggleOldName}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') toggleOldName(event);
                }}
                className={classnames('rentalRow__renameToggle', {
                  btnCollapse: showOldName,
                  btnExpand: !showOldName,
                })}
              >
                {showOldName ? <ArrowUp /> : <ArrowDown />}
              </span>
            )}
          </p>
          {wasRenamed && showOldName && (
            <p className='rentalRow__oldName'>
              Formerly: {rentalInventory.name}
            </p>
          )}
          <p className='rentalRow__rentalToken'>{orderLabel}</p>
        </td>
        <td className='middle'>
          {startDate && (
            <FormattedDate
              value={new Date(startDate)}
              day='2-digit'
              month='2-digit'
            />
          )}
          {' - '}
          {endDate && (
            <FormattedDate
              value={new Date(endDate)}
              day='2-digit'
              month='2-digit'
              year='2-digit'
            />
          )}
        </td>
        <td className='middle no-wrap'>{sub_rental?.supplier}</td>
        <td className='middle'>{sub_rental?.customer_name}</td>
        <td className='middle'>{sub_rental?.contact}</td>
        <td className='middle'>
          {sub_rental?.expense && sub_rental.expense > 0 && (
            <FormattedNumber
              value={sub_rental.expense}
              style='currency'
              currency='USD'
            />
          )}
        </td>
        <td rowSpan={2} className='alert'>
          <WithSubRentals className={has_shortage ? 'orange' : 'green'} />
        </td>
      </Link>
    </tbody>
  );
};

export default SubrentalsAllRow;
